export default (token) => {
	return localStorage.setItem('USER-TOKEN', token)
}
